import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import * as queryString from 'query-string';
import Cookies from "cookies-js";
import ConfirmationModal from "../common/ConfirmationModal";

import * as d from "../../reducers/domainReducer";
import { getURLPath, getDomain, getMyChartCookieName } from '../../helpers/Tools';
import { logUI } from '../../api/andyliticsApi';
import SectionLoading from '../common/SectionLoading';
import Spinner from '../common/spinner';
import SectionLoadingError from "../common/SectionLoadingError";
import * as types from "../../constants/actionTypes";
import * as tools from "../../helpers/Tools";
import * as qs from "query-string";
import ActivityDetectionFrame from "../common/ActivityDetectionFrame";//
import { MyChartHeading } from "../ecosystem/mybswh";

/**
 * MyChart Visits Data Tile.
 * 
 */
class MyChartDataTile extends React.Component {
    constructor(props) {
        super(props);
        var _byroute = false;
        var _mode = '';
        var _submode = '';
        var _form = '';
        var _hideLinks = false;
        this.toggleMyChartDTLinks = this.toggleMyChartDTLinks.bind(this);

        this.serverData = this.props.serverData;
        //debugger;
        if (this.props.byroute) { _byroute = props.byroute; }
        if (this.props.mode) { _mode = props.mode; }
        if (this.props.submode) { _submode = props.submode; }
        if (this.props.formName) { _form = props.formName; }
        if (this.props.match.params.formName) {
            _form = this.props.match.params.formName;
        }
        if (this.props.navigation === "hide") {
            _mode = this.props.mode;
            _submode = this.props.submode;
            _hideLinks = true;
            const jsonData = (_submode && _submode.length > 0) ? JSON.stringify({ submode: _submode, mode: _mode }) : JSON.stringify({ mode: _mode });
            const subActivityCode = (_mode && _mode.length) ? "." + this.parseModeForLogging(_mode) : "" + (_submode && _submode.length) ? "." + this.parseModeForLogging(_submode) : "";
            logUI("MBHWeb.UI.MyChart.DataTile" + subActivityCode, new Date(), getURLPath(), jsonData);
        }

        this.state = {
            showDTLinks: true,
            hideLinks: _hideLinks,
            mode: _mode,
            submode: _submode,
            byroute: _byroute,
            loaded: false,
            sectionLoadingError: false,
            onError: false,
            //touched: false,
            form: _form,
            localizationlabel: navigator && navigator.language && navigator.language.indexOf('es') === 0 ? 'View In English' : 'Ver en Español'
        };
        this.onLocalizationChangeClick = this.onLocalizationChangeClick.bind(this);
        this.processWindowMessage = this.processWindowMessage.bind(this);
        this.onIframeLoaded = this.onIframeLoaded.bind(this);
        this.onError = this.onError.bind(this);
        
    }

    componentDidMount() {
        var myDomain = getDomain();
        this._isMounted = true;
        window.formChanged = false;
        window.isMyChartPage = true;
        logUI("MBHWeb.MyChartDataTile.ComponentDidMount", new Date(), getURLPath());
        var sMyChartCookieName = getMyChartCookieName();
        var sMyChartCookieValue = Cookies.get(sMyChartCookieName);
        this.props.touch(false);
        // this is a hack to cover a timing issue where the cookie doesn't get set until the app comes to rest (after a login)
        //debugger;
        if ((sMyChartCookieValue == null || sMyChartCookieValue == "")) {
            //debugger;
            if (this.props.token) {
                Cookies.set(sMyChartCookieName, this.props.token, { path: '/', domain: myDomain });
            }
        }
        Cookies.set('BSWLOCAL', navigator && navigator.language && navigator.language.indexOf('es') === 0 ? 'espanol' : 'english', { expires: Infinity, path: '/', domain: myDomain });
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log(`Replaced HTML.... ${window.document.getElementById("bsw_qtx")},props,state`,this.props,this.state);
        //if (this.props?.redirectUrl !== '') {
        //    this.props.history.push(this.props.redirectUrl);
        //}
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.formChanged = false;
        window.removeEventListener("message", this.processWindowMessage);
        window.isMyChartPage = false;
    }

    toggleMyChartDTLinks() {
        //debugger;
        this.setState(function (prevState, props) { return { showDTLinks: !prevState.showDTLinks }; });
    }

    //For now just looking for & if anything other special chars added then need to formating here.
    parseModeForLogging(activityCode) {
        return activityCode && activityCode.indexOf('&') > -1 ? activityCode.split("&")[0] : activityCode;
    }

    onLocalizationChangeClick(e) {
        var myDomain = getDomain();
        var localization = '';
        if (Cookies.get('BSWLOCAL'))
            localization = Cookies.get('BSWLOCAL');
        if (localization && localization.length > 0) {
            if (localization === 'espanol') {
                Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
                this.setState({ localizationlabel: "Ver en Español" });
            }
            else {
                Cookies.set('BSWLOCAL', 'espanol', { expires: Infinity, path: '/', domain: myDomain });
                this.setState({ localizationlabel: "View In English" });
            }

        }
        else {
            Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
            localization = 'english'
            this.setState({ localizationlabel: "Ver en Español" });

        }
        const localeLog = (localization && localization.length > 0) ? ((localization === 'english') ? 'espanol' : 'english') : 'unknown';
        logUI("MBHWeb.MyChart.DataTile.LocaleChange." + localeLog, new Date(), getURLPath(), '');
    }

    OnInitializingIframe(mode, subMode) { }

    /**
     * This looks for there to be a query match inside the observed element.
     * In the future tweaks for multiple actions and match pairs can start here.
     * For now only one match is handled and it sets touched and formChanged to false.
     * Setting these to false prevents the you have unsaved data message.
     * @param {any} messageEvent
     */
    processWindowObservation(messageEvent) {

        try {

            //console.info(`MyChartDataTile processWindowObservation START parent onObserved ${typeof this.props.onObserved}`, messageEvent);
            if (this.props.bswMatch && messageEvent.data.event === "bswMatchedMutation"
                && messageEvent.data.data.type === "childList"
                && messageEvent.data.data.target === this.props.bswMatch) {
                //console.info(`MyChartDataTile processWindowObservation got the expected tag added`, messageEvent);
                //this.props.touch(false);
                window.formChanged = false;
            }
            if (this.props.onObserved && (typeof this.props.onObserved === "function")) {
                this.props.onObserved(messageEvent);
            }
        } catch (e) {
            console.error(`MychartDataTile processWindowObservation ERROR`, messageEvent, this.props);
        }

    }

    processWindowMessage(messageEvent) {

        const eventData = messageEvent?.data?.evt || messageEvent.data;
        console.info(`MyChartDataTile processWindowMessage message eventData, messageEvent`, eventData,messageEvent);
        try {
            if (messageEvent.data.source && messageEvent.data.source.indexOf('react-') != -1) {
                //console.info(`MyChartDataTile processWindowMessage react event IGNORE`, messageEvent.data);
            } else if (!eventData) {
                //console.info(`MyChartDataTile processWindowMessage What is this? `, eventData,messageEvent);
            } else if (eventData.message === "touched") {
                //this default event is happening to frequently causing the formChanged flag to be
                //set before any meaninful change has occured.
                //debugger;
                //console.info(`MyChartDataTile processWindowMessage TOUCHED`, messageEvent.data);
                //window.formChanged = true;
                this.props.touch(true);
            } else if (eventData.message === "childFrameChangeIgnored") {
                //debugger;
                window.formChanged = false;
            } else if (this.props.onMessage) {
                //console.info(`MyChartDataTile processWindowMessage calling props.onMessage`, messageEvent.data);
                if (this.props.onMessage && typeof this.props.onMessage === "function") {
                    this.props.onMessage(messageEvent);
                }
            }
            this.props.onMessage(messageEvent);
        } catch (e) {
            console.error(`MychartDataTile processWindowMessage ERROR messageEvent`, messageEvent);
            console.error(`MychartDataTile processWindowMessage ERROR`, e);
        }
    }

    onIframeLoaded(event) {
        //console.info(`MyChartDataTile onIframeLoaded loaded?${this.props.onIframeLoaded} event`, event);
        if (!this.state.loaded) {
            this.setState({ loaded: true }); // initCallback not called in case of error so hiding spinner here.
            if (this.props.onIframeLoaded)
                this.props.onIframeLoaded(true);
        }
        if (this.props.mode && this.props.mode.toLowerCase() === 'questionnairelist' && event && event.contentDocument && event.contentDocument.location.search) {
            let redirectMode = queryString.parse(event.contentDocument.location.search);
            if (redirectMode && redirectMode.mode && redirectMode.mode === 'proxyaccess' && this.state.sectionLoadingError === false) {
                this.setState({ sectionLoadingError: true });
            }
        }
    }

    reloadIfOnSamePage = (pathname) => {
        const { location, forceReload, leaveOnWindowChange } = this.props;
        if (pathname === location.pathname) {
            forceReload();
        }
        if (typeof leaveOnWindowChange !== 'undefined' && leaveOnWindowChange) {
            leaveOnWindowChange(pathname);
        }
    }

    onError() {
        if (!this.state.onError) {
            this.setState({ onError: true });
            if (this.props.mychartError) this.props.mychartError();
        }
    }

    blockNavigation = (nextLocation) => {
        const { dontShowModalRoute } = this.props;
        const re = new RegExp(`${dontShowModalRoute}`);
        return nextLocation !== null && re.test(nextLocation.pathname);
    }

    render() {

        //debugger;
        const { hasMyChart, reloadKey, needSectionError, title, showLanguageLink, confirmationModalMsg, confirmationModalBtnTxt1,
            confirmationModalBtnTxt2, dontShowModalRoute, src, touched, ignoreTouch, isSubSection  } = this.props;
        const enableLanguageLink = showLanguageLink !== undefined ? showLanguageLink : true;
        const sAdditionalScripts = [window.location.origin + '/scripts/childChangeDetection.js'];
        const { loaded, sectionLoadingError, onError, form } = this.state;

        var myDomain = getDomain();

        //Cookies.set('BSWSSO', this.props.token, { path: '/', domain: myDomain }); // Just in case

        if ((!hasMyChart && !this.props.src)) {
            //debugger;
            return <div></div>;
        }

        var mode = '';
        var submode = '';
        var localization = '';
        if (this.state.byroute && this.state.byroute === 'true') {
            mode = this.props.match.params.mode;
            submode = this.props.match.params.submode;
        }
        else {
            mode = this.props.mode;
            submode = this.props.submode;
        }

        // Pull any querystring parameters anyone may have set in the src parameter
        var oInQueryParams = [];
        if (this.props.src) {
            const thisSrc = new URL(this.props.src);
            if (thisSrc.searchParams) {
                thisSrc.searchParams.forEach(function (value, key) {
                    key = key.toLowerCase();
                    if (key != "mode" && key != "lang" && key != "reloadkey") {
                        oInQueryParams.push({ "key": key, "value": value });
                    }
                });
            }
        }
        if (mode && mode.indexOf("&") > -1) {
            var moreParams = mode.split("&");
            mode = moreParams[0]; // we are assuming the mode is the first value in the set due to the hack method
            for (var i = 1; i < moreParams.length; i++) {
                var splits = moreParams[i].split("=");
                if (splits.length > 1) {
                    oInQueryParams.push({ "key": splits[0], "value": splits[1] });
                }
            }
        }


        var m = null;
        var hideLinks = true;

        if (this.props.token) {
            // we can't do this hear because MyChart cache's the original token used
            //Cookies.set('BSWSSO', this.props.token, { path: '/', domain: myDomain }); // Just in case
        }
        if (typeof window !== "undefined") {
            if (this.props.currentUser &&
                this.props.currentUser.relationshipId) {
                //Cookies.set('BSWSSO', this.props.token, { path: '/', domain: myDomain });   // we need to not modify this cookie, not that this was really doing anything

                // ----> commenting out setting cookie if it helps resolve iFrame loading issue
                //Cookies.set('BSWPROXY', this.props.currentUser.relationshipId, { path: '/', domain: myDomain });
                m = Cookies.get('BSWPROXY') || this.props.currentUser.relationshipId;
            }
            else {
                // ----> commenting out setting cookie if it helps resolve iFrame loading issue
                //Cookies.set('BSWPROXY', '', { path: '/', domain: myDomain });
                m = null;
            }

            if (Cookies.get('BSWLOCAL'))
                localization = Cookies.get('BSWLOCAL');
        }
        var mclink = this.props.serverData.myChartUrl;

        m = Cookies.get('BSWPROXY');
        var url = `${this.props.serverData.myChartDataTileUrl}${mode}` + '&m=' + (m ? `${m}` : '');
        if (submode && submode.length > 0)
            url += "&submode=" + submode;
        if (localization && localization.length > 0)
            url += "&lang=" + localization;
        else {
            url += '&lang=english';
            localization = "english";
        }

        // what the hell is??
        var mcurl = `${this.props.serverData.myChartUrl}${mode}&reloadKey=${reloadKey}`;
        //url = mcurl;
        //debugger;
        if (oInQueryParams.length > 0) {
            //debugger;
            oInQueryParams.forEach((parm, index) => {
                if (parm.key) {
                    if (url.toLowerCase().indexOf(parm.key.toLowerCase()) == -1) {
                        url += "&" + parm.key + "=" + encodeURIComponent(parm.value);
                    }
                }
            });
        }
        if (form) {
            //debugger;
            mcurl = `${this.props.serverData.myChartVisitsDataTileUrl}showform&formname=${form}&reloadKey=${reloadKey}`;
            url = mcurl;
        }
        else {
            //debugger;
            url = this.props.src || this.props.url || url;
        }
        //debugger;
        // Replace URL here
        if (window.serverData.data.useMyChartShim) {

            var queryParams = [{ key: "reloadKey", value: reloadKey },
            { key: "lang", value: (localization && localization.length > 0) ? localization : "english" }]
            if (oInQueryParams.length > 0) {
                queryParams.push.apply(queryParams, oInQueryParams);
            }

            if (window.serverData.data.mergeMyChart) {
                queryParams.push({ key: "selfreference", value: "1" });
            }

            //debugger;
            switch (true) {
                case url.toLowerCase().indexOf("openscheduling") > -1:
                    url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/openscheduling`, queryParams);
                    break;
                case url.toLowerCase().indexOf("billing/guestpay/payasguest") > -1:
                    url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/payasguest`, queryParams);
                    break;
                case url.toLowerCase().indexOf("/Visits/GuestCancel") > -1:
                    const qpForCancelVisit = qs.parse(this.props.location.search);
                    const csnForCancelVisit = qpForCancelVisit && qpForCancelVisit.csn ? qpForCancelVisit.csn : "";
                    url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/GuestCancelVisit?csn=${csnForCancelVisit}`, queryParams);
                    break;
            }
            if (mode) {
                switch (mode.toLowerCase()) {
                    case "showform":
                        if (form) {
                            url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/showform?formname=${form}`, queryParams);
                            break;
                        }
                    case "messages":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/messages`, queryParams);
                        queryParams.forEach(param => {
                            if (param.key === "folder") {
                                //`https://mycharttest.bswhealth.com`
                                url = tools.buildUrl(window.serverData.data.myChartBaseUrl, `/app/communication-center`, [param]);
                            }
                        });


                        //url = mcurl;
                        //console.info(`MyChartDataTile medicalURL ${window.serverData.data.medicalRecordURL} url ${url} queryParams `, queryParams);

                        break;
                    case "accountsummary":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/accountsummary`, queryParams);
                        break;
                    case "documents":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/documents`, queryParams);
                        break;
                    case "patientestimates":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/patientestimates`, queryParams);
                        break;
                    case "growthchart":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/growthchart`, queryParams);
                        break;
                    case "medadvice":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/advice`, queryParams);
                        break;
                    case "onmyway":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/onmyway`, queryParams);
                        break;
                    case "scheduling":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/scheduling`, queryParams);
                        break;
                    case "myconditions":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/myconditions`, queryParams);
                        break;
                    case "labs":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/labs`, queryParams);
                        break;
                    case "healthmaint":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/healthmaint`, queryParams);
                        break;
                    case "pefltlst":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/track`, queryParams);
                        break;
                    case "fshreportlist":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/trends`, queryParams);
                        break;
                    case "appointments":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/visits/visitdetails`, queryParams);
                        break;
                    case "visitsummary":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/visitsummary`, queryParams);
                        break;
                    case "visits":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/visits`, queryParams);
                        break;
                    case "walletcard":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/walletcard`, queryParams);
                        break;
                    case "shareverywhere":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/shareverywhere`, queryParams);
                        break;
                    case "patinfo":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/patientinfo`, queryParams);
                        break;
                    case "acp":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/advancedirectives`, queryParams);
                        break;
                    case "allergies":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/allergies`, queryParams);
                        break;
                    case "insurance":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/insurance`, queryParams);
                        break;
                    case "hlthissues":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/healthissues`, queryParams);
                        break;
                    case "medslist":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/medications`, queryParams);
                        break;
                    case "audit":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/audit`, queryParams);
                        break;
                    case "snapshot":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/healthsummary`, queryParams);
                        break;
                    case "immunizations":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/immunizations`, queryParams);
                        break;
                    case "letters":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/letters`, queryParams);
                        break;
                    case "histories":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/medicalhistory`, queryParams);
                        break;
                    case "planofcare":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/planofcare`, queryParams);
                        break;
                    case "questionnairelist":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/questionnaires`, queryParams);
                        break;
                    case "showrep":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/showrep?submode=${submode}`, queryParams);
                        break;
                    case "upcomingtests":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/upcomingtests`, queryParams);
                        break;
                    case "communitymanage":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/managecommunityaccounts`, queryParams);
                        break;
                    case "schedotherprefs":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/preferences`, queryParams);
                        break;
                    case "mycondition":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/myconditions`, queryParams);
                        break;
                    case "echeckin":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/echeckin?mode=${mode}`, queryParams);
                        break;
                    case "paperless":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/paperless`, queryParams);
                        break;
                    case "covidstatus":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/covidstatus`, queryParams);
                        break;
                    case "todos":
                        url = tools.buildUrl(window.serverData.data.medicalRecordURL, `/todo`, queryParams);
                        break;
                }
            }
        }



        const navLinkStyle = {
            //float: 'left'            
        };
        const navMenuStyle = {
            float: 'left',
            position: 'fixed',
            'backgroundColor': 'aliceblue',
            'zIndex': '20',
            left: '127px',
            padding: '20px',
            borderRadius: '0px 10px 0px 10px'
        };
        const rotate90 = { transform: 'rotate(90deg)', position: 'relative', top: '25px', left: '-10px', zIndex: '30' };
        const rotate45 = { transform: 'rotate(-45deg)', border: '2px solid', 'borderRadius': '50px', height: '30px', width: '30px', 'paddingLeft': '7px', 'paddingTop': '2.5px' };
        const rotate270 = { transform: 'rotate(270deg)', position: 'relative', top: '25px', left: '-10px', zIndex: '30' };
        const hide = { display: 'none', float: 'left' };
        const crazyWidth = { float: 'right', top: '19px', left: '-35px', position: 'relative', 'zIndex': '10' };
        const moveLeft = { position: 'relative', left: '0px' };
        //const noLinks = { marginLeft: '5px', marginTop:'5px', height:'1400px' };
        const noLinks = {};//{ height: '100%' };
        const iframeResizerOptions = { checkOrigin: false, minHeight: 400, scrolling: true, heightCalculationMethod: 'bodyScroll', initCallback: () => this.OnInitializingIframe(mode, submode), warningTimeout: 10000 };
        const iframeResizerStyle = this.props.style || { width: '100%' };
        //debugger;
        const formID = this.props.id || "mychart" + mode;
        const iframeTitle = this.props.title || mode;
        const loader = this.props.partialView ? <SectionLoading /> : <Spinner />;
        //debugger;
        const style = this.props.containerClass === "hidden" ? {
            "width": '0%', "minHeight": "0px", "height": "0px"
        } : {
            "width": '100%', "minHeight": "20px", "height": "400px"
        };
        //console.log('myChartDataTile: cookie BSWPROXY:', Cookies.get('BSWPROXY'), 'url:', url,this.props);

        const frame = React.createRef();
        return (
            <React.Fragment>
                {!onError ?
                    <React.Fragment>
                        {!loaded && loader}
                        {!sectionLoadingError || !needSectionError ?
                            <div style={noLinks} className="mychartDataTile">
                                <div style={!hideLinks ? moveLeft : hide} >
                                    <div onClick={this.toggleMyChartDTLinks} className={this.state.showDTLinks ? '' : 'hidden'} style={navLinkStyle}>
                                        <div className="menu-icon" style={rotate90}><span className="icon-arrow-sm-down"></span></div>
                                    </div>
                                    <div onClick={this.toggleMyChartDTLinks} className={this.state.showDTLinks ? 'hidden' : ''} style={navLinkStyle}>
                                        <div className="menu-icon" style={rotate270}><span className="icon-arrow-sm-down"></span></div>
                                    </div>

                                </div>
                                {(mode || this.props.src || form) &&
                                    <div style={navLinkStyle} className="mychartDataTile-content">
                                        {/*{enableLanguageLink && <div className="language-link-container"><div className="link-style language-link" onClick={this.onLocalizationChangeClick} >{localization === "english" ? 'Ver en Español' : 'View in English'}</div></div>} */}
                                        {enableLanguageLink && <MyChartHeading ctaOnly={true} isSubSection={isSubSection} /> }
                                        <a className="nav-link" href={mcurl} target="_blank" style={!hideLinks ? crazyWidth : hide} >
                                            <div >
                                                <div className="menu-icon" style={rotate45}><span className="icon-arrow-sm-rt"></span></div>
                                            </div>
                                        </a>
                                        {(false && this.props.bswProxySwitching)
                                            ? <Spinner />
                                            :
                                            <ActivityDetectionFrame
                                                id="mychartDataTile"
                                                name="mychartDataTile"
                                                innerRef={frame}
                                                src={url}
                                                frameBorder={0}
                                                style={style}
                                                title={title ? title : ""}
                                                onLoad={this.onIframeLoaded}
                                                border="0px"
                                                ignoreChanges={this.props.ignoreChanges}
                                                events={this.props.events}
                                                observe={`${this.props.observe ? this.props.observe : ""}`}
                                                bswMatch={`${this.props.bswMatch ? this.props.bswMatch : ""}`}
                                                onMessage={(data) => { this.processWindowMessage(data); }}
                                                onObserved={(data) => { this.processWindowObservation(data); }}
                                                containerClass={this.props.containerClass}
                                            />

                                        }
                                        {this.props.showQTXSurvey && <div id={this.props.bswQtxID && this.props.bswQtxID.length > 0 ? this.props.bswQtxID : "bsw_qtx"} />}

                                        {/* <ReactIframeResizer additionalScripts={sAdditionalScripts} ref="thisFrame" key={reloadKey} id={formID} title={iframeTitle} iframeResizerOptions={iframeResizerOptions} src={url} style={iframeResizerStyle} onIframeLoaded={this.onIframeLoaded} onError={this.onError} /> */}
                                        {/*         <Iframe url={url} id="mychartframe" className="" display="initial" scrolling="yes" /> */}
                                    </div>
                                }
                            </div> : <SectionLoadingError message="This feature is not available." sectionErrorClass="not-available-error" titleIcon="icon-log-out" />}
                    </React.Fragment> : <SectionLoadingError message="Failed to load. Please try again later." />}
                {(touched) &&
                    <ConfirmationModal when={touched} actionText1={confirmationModalBtnTxt1 ? confirmationModalBtnTxt1 : 'STAY ON THIS PAGE'} actionText2={confirmationModalBtnTxt2 ? confirmationModalBtnTxt2 : 'CONTINUE WITHOUT SAVING'} message={confirmationModalMsg ? confirmationModalMsg : "Would you like to leave this page and lose changes?"} callbackOnLeave={this.reloadIfOnSamePage} blockNavigation={dontShowModalRoute ? this.blockNavigation : null} />
                }
                <script>console.log("processed frame html");</script>
            </React.Fragment>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const primaryUserDomain = d.hydrateProxyUser(state.domain.pu);
    const primaryUserSSO = state.sso.primaryUser;
    let primaryUser = primaryUserDomain || primaryUserSSO;

    return {
        loginStatus: state.domain.ls,
        proxyList: state.memberships.proxyList,
        primaryUser: primaryUser,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        token: state.domain.t,
        reloadKey: state.session.reloadKey,
        touched: state.myChartDataTile.touched,
        onMessage: ownProps.onMessage,
        onObserved: ownProps.onObserved,
        myChartDatatileLang: state.myChartDataTile.myChartDatatileLang
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        forceReload: () => dispatch({ type: types.RELOAD_KEY }),
        touch: (isTouched) => dispatch({ type: types.MYCHART_DATA_TILE_TOUCHED, data: { touched: isTouched } })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyChartDataTile));